import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommonRootState } from '@common/types/common-root-state-type';

export interface DocumentProgress {
    documentId: string;
    stage: 'upload' | 'extraction' | 'chunking' | 'embedding' | 'error';
    progress: number;
    currentChunk?: number;
    totalChunks?: number;
    status: 'processing' | 'completed' | 'error';
    error?: string;
    userId: string;
    knowledgeBaseId: string;
}

interface KnowledgeBaseProgressState {
    documentsInProgress: Record<string, DocumentProgress>;
}

const initialState: KnowledgeBaseProgressState = {
    documentsInProgress: {}
};

const knowledgeBaseProgressSlice = createSlice({
    name: 'knowledgeBaseProgress',
    initialState,
    reducers: {
        updateDocumentProgress: (state, action: PayloadAction<DocumentProgress>) => {
            const progress = action.payload;
            
            // If the document is completed or errored, remove it from the progress tracking
            if (progress.status === 'completed' || progress.status === 'error') {
                delete state.documentsInProgress[progress.documentId];
            } else {
                state.documentsInProgress[progress.documentId] = progress;
            }
        },
        clearProgress: (state, action: PayloadAction<string>) => {
            delete state.documentsInProgress[action.payload];
        },
        clearAllProgress: (state) => {
            state.documentsInProgress = {};
        }
    }
});

// Selectors
export const selectDocumentProgress = (state: CommonRootState, documentId: string) => 
    state.KnowledgeBaseProgressReducer.documentsInProgress[documentId];

export const selectAllDocumentsInProgress = (state: CommonRootState) => 
    state.KnowledgeBaseProgressReducer.documentsInProgress;

export const selectDocumentsInProgressForKnowledgeBase = (state: CommonRootState, knowledgeBaseId: string) => 
    Object.values(state.KnowledgeBaseProgressReducer.documentsInProgress)
        .filter((progress: DocumentProgress) => progress.knowledgeBaseId === knowledgeBaseId);

export const { updateDocumentProgress, clearProgress, clearAllProgress } = knowledgeBaseProgressSlice.actions;
export default knowledgeBaseProgressSlice.reducer; 